const fetch = (url, options) => {
  return window.fetch(url, options).then((response) => response.json());
};

export default fetch;